import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useEffect } from "react";

import { PREFERRED_PERSISTENCE_LOCAL_STORAGE_KEY_NAME } from "./constants";

export function useSetPreferredPersistenceForAuth() {
  const { preferredPersistence } = useCbhFlag(CbhFeatureFlag.PREFERRED_PERSISTENCE_FOR_AUTH, {
    defaultValue: {},
  });

  useEffect(() => {
    logEvent(APP_V2_APP_EVENTS.SET_PREFERRED_PERSISTENCE_FOR_AUTH, {
      preferredPersistence,
    });

    if (isDefined(preferredPersistence)) {
      localStorage.setItem(PREFERRED_PERSISTENCE_LOCAL_STORAGE_KEY_NAME, preferredPersistence);
    }
  }, [preferredPersistence]);
}
